import React, { ReactElement } from 'react';
import { Icon } from '@dexma/ui-components';
import i18n from 'asset/translation';
import { countIssuesBySeverity, WidgetIssue, WIDGET_ISSUE_SEVERITY_ORDER } from 'domain/entity/widgetIssue';
import { useGeneratePDF } from 'adapter/in/reports/contexts/GeneratePDFContext';
import { severityLabel, widgetIssueTokens } from 'adapter/in/reports/utils/widgetIssues';
import { WIDGET_ISSUE_I18N } from 'adapter/in/reports/utils/widgetIssuesConstants';
import { StyledBadge, StyledBadgeRow } from 'adapter/in/reports/components/WidgetIssueBadges/style';

type WidgetIssueBadgesProps = {
    issues: WidgetIssue[];
    onOpen: () => void;
};

const WidgetIssueBadges = ({ issues, onOpen }: WidgetIssueBadgesProps): ReactElement | null => {
    const { generatingPDF } = useGeneratePDF();

    if (generatingPDF || issues.length === 0) return null;

    const counts = countIssuesBySeverity(issues);
    const severities = WIDGET_ISSUE_SEVERITY_ORDER.filter((severity) => counts[severity] > 0);

    return (
        <StyledBadgeRow data-testid='widget-issue-badges'>
            {severities.map((severity) => {
                const tokens = widgetIssueTokens(severity);
                return (
                    <StyledBadge
                        key={severity}
                        type='button'
                        $bg={tokens.badgeBg}
                        $text={tokens.badgeText}
                        aria-label={i18n.t(WIDGET_ISSUE_I18N.badgeAriaLabel, { count: counts[severity], severity: severityLabel(severity) })}
                        onClick={(event: any) => {
                            event.stopPropagation();
                            onOpen();
                        }}
                    >
                        <Icon name={tokens.icon} size={14} color={tokens.badgeText} ariaLabel={severityLabel(severity)} />
                        <span>{counts[severity]}</span>
                    </StyledBadge>
                );
            })}
        </StyledBadgeRow>
    );
};

export default WidgetIssueBadges;
